import { getFetchWrapper } from '@syf-api-library/core';
import ENDPOINTS from '../../const/endpoints';
const mutationFnFactory = (config, keyProps) => {
    const fetchWrapper = getFetchWrapper(config);
    return () => fetchWrapper(`${ENDPOINTS.debtCancellation}`, {
        method: 'PUT',
        body: JSON.stringify(keyProps)
    });
};
export default mutationFnFactory;
